import { BreakpointObserver } from '@angular/cdk/layout';
import {
  EventEmitter,
  Injectable,
  computed,
  inject,
  signal,
} from '@angular/core';
import { toSignal } from '@angular/core/rxjs-interop';
import { map, filter } from 'rxjs';
import resolveConfig from 'tailwindcss/resolveConfig';
import tailwindConfig from '../../../../tailwind.config';
import { Router, NavigationEnd } from '@angular/router';

@Injectable({
  providedIn: 'root',
})
export class AppService {
  breakpointObserver = inject(BreakpointObserver);
  private router = inject(Router);

  constructor() {
    this.router.events
      .pipe(filter((event) => event instanceof NavigationEnd))
      .subscribe((event: NavigationEnd) => {
        this.currentView.set(event.urlAfterRedirects.slice(1).split('?')[0]);
      });
  }

  takeScreenshot = new EventEmitter();
  fastForward = new EventEmitter();
  fastBackward = new EventEmitter();
  pauseVideo = new EventEmitter();
  replayVideo = new EventEmitter();

  showConsole = signal(false);
  debugMode = signal(false);
  demoMode = signal(false);
  showOverlays = signal(true);
  showUI = signal(true);

  dominantHand = signal<'right' | 'left'>('right');

  appState = signal<'success' | 'canceled' | 'noCamera'>('success');
  fullScreen = signal(false);
  showSideBar = signal(false);
  cameraId = signal('');
  showSceneLauncher = signal(false);
  trackingMode = signal(false);
  sampleMovie = signal<string>(null);
  theme = resolveConfig(tailwindConfig);
  currentView = signal('');

  isPortraitMode = toSignal(
    this.breakpointObserver
      .observe(['(orientation: portrait)', '(orientation: landscape)'])
      .pipe(map((result) => result.breakpoints['(orientation: portrait)'])),
  );

  cameraConfig = computed(() => ({
    deviceId: this.cameraId() ? { exact: this.cameraId() } : undefined,
    frameRate: { ideal: 30 },
    width: { ideal: 1280 },
    height: { ideal: 720 },
  }));
}
